import { trackAbTestEvent } from 'dibs-tracking';
import { getAbTestEligibility, AB_CONSTANTS } from 'dibs-cookie-jar/exports/abTestHelpers';

export const trackAaaaTest = (): void => {
    const { group } = getAbTestEligibility(document.cookie);

    if (
        [
            AB_CONSTANTS.CDN_TEST_1,
            AB_CONSTANTS.CDN_TEST_2,
            AB_CONSTANTS.CDN_TEST_3,
            AB_CONSTANTS.CDN_TEST_4,
            AB_CONSTANTS.SHARED_CONTROL_GROUP,
        ].includes(group)
    ) {
        const testGroup = group === AB_CONSTANTS.SHARED_CONTROL_GROUP ? 'control' : 'variant';
        const groupName = group === AB_CONSTANTS.SHARED_CONTROL_GROUP ? 'sharedControl' : group;

        trackAbTestEvent(
            {
                testGroup,
                additional: {
                    [groupName]: `AAAA_TEST - ${testGroup.toUpperCase()}`,
                },
            },
            'aaaa test'
        );
    }
};
